import { render, staticRenderFns } from "./OutagesTableDesktop.vue?vue&type=template&id=533ef691&scoped=true"
import script from "./OutagesTableDesktop.vue?vue&type=script&lang=js"
export * from "./OutagesTableDesktop.vue?vue&type=script&lang=js"
import style0 from "./OutagesTableDesktop.vue?vue&type=style&index=0&id=533ef691&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ef691",
  null
  
)

export default component.exports